var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolCurvedDistance = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  transform: "translate(4 4)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M2 18c1-9 9-3 16-16"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 18,
  r: 2.2,
  fill: "currentColor",
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 11.5,
  r: 1.8,
  fill: "currentColor",
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 2,
  r: 2.2,
  fill: "currentColor",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M0 18h4M16 2h4"
})))));
export { SvgToolCurvedDistance as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-curved-distance.svg";